import axios from "axios";

import {
  FETCH_TEAM_MEMBERS,
  FETCH_MY_TEAM_PERMISSIONS,
} from "../constants/teamMembers";

const TEAM_MEMBERS_BASE_URL = `${process.env.REACT_APP_API_URL}/dashboard/apiv2`;

const authHeaders = (token) => ({
  "Content-Type": "application/json",
  Authorization: `Token ${token}`,
});

export const fetchTeamMembers = () => async (dispatch, getState) => {
  const token = getState().auth.token;
  if (!token) return;

  const response = await axios.get(`${TEAM_MEMBERS_BASE_URL}/team-members/`, {
    headers: authHeaders(token),
  });
  dispatch({ type: FETCH_TEAM_MEMBERS, data: response.data });
  return response.data;
};

export const createTeamMember = (data) => async (dispatch, getState) => {
  const token = getState().auth.token;
  if (!token) return;

  const response = await axios.post(
    `${TEAM_MEMBERS_BASE_URL}/team-members/`,
    data,
    { headers: authHeaders(token) }
  );
  await dispatch(fetchTeamMembers());
  return response.data;
};

export const updateTeamMember = (id, data) => async (dispatch, getState) => {
  const token = getState().auth.token;
  if (!token) return;

  const response = await axios.patch(
    `${TEAM_MEMBERS_BASE_URL}/team-members/${id}/`,
    data,
    { headers: authHeaders(token) }
  );
  await dispatch(fetchTeamMembers());
  return response.data;
};

export const deleteTeamMember = (id) => async (dispatch, getState) => {
  const token = getState().auth.token;
  if (!token) return;

  await axios.delete(`${TEAM_MEMBERS_BASE_URL}/team-members/${id}/`, {
    headers: authHeaders(token),
  });
  await dispatch(fetchTeamMembers());
};

export const fetchMyTeamPermissions = () => async (dispatch, getState) => {
  const token = getState().auth.token;
  if (!token) return;

  const response = await axios.get(
    `${TEAM_MEMBERS_BASE_URL}/my-team-permissions/`,
    { headers: authHeaders(token) }
  );
  dispatch({ type: FETCH_MY_TEAM_PERMISSIONS, data: response.data });
  return response.data;
};
